<template>
  <div v-if="filters" class="d-flex flex-column">
    <template v-for="(section, i) in visibleSections" :key="i">

      <!-- Sort -->
      <SortControl
        v-if="section.type === 'sort'"
        :model-value="getByPath(filters, section.fieldKey)"
        @update:model-value="v => setByPath(filters, section.fieldKey, v)"
        :ascending="getByPath(filters, section.ascendingKey)"
        @update:ascending="v => setByPath(filters, section.ascendingKey, v)"
        :direction-label="section.directionLabel(getByPath(filters, section.fieldKey), getByPath(filters, section.ascendingKey))"
      >
        <option v-for="opt in section.options" :key="opt.value" :value="opt.value">{{ opt.label }}</option>
      </SortControl>

      <!-- Switch -->
      <div v-else-if="section.type === 'switch'" class="filter-section">
        <div class="filter-row">
          <label class="filter-label">{{ section.label }}</label>
          <div class="filter-row-content">
            <BSwitch
              :model-value="getByPath(filters, section.key)"
              @update:model-value="v => setByPath(filters, section.key, v)"
            />
          </div>
        </div>
      </div>

      <!-- Segmented -->
      <div v-else-if="section.type === 'segmented'" class="filter-section">
        <label class="filter-label">{{ section.label }}</label>
        <SegmentedControl
          :model-value="getByPath(filters, section.key)"
          @update:model-value="v => setByPath(filters, section.key, v)"
          :options="section.options"
        />
      </div>

      <!-- Select -->
      <div v-else-if="section.type === 'select'" class="filter-section">
        <div class="filter-row">
          <label class="filter-label">{{ section.label }}</label>
          <div class="filter-row-content">
            <select
              :value="getByPath(filters, section.key)"
              @input="setByPath(filters, section.key, $event.target.value === '' ? null : $event.target.value)"
              class="form-select form-select-sm flex-grow-1"
              style="border-color:#ccc"
            >
              <option :value="null">{{ section.placeholder || '' }}</option>
              <option
                v-for="opt in resolveOptions(section)"
                :key="opt.value"
                :value="opt.value"
              >{{ opt.label }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Chips (Custom) -->
      <div v-else-if="section.type === 'chipsCustom'" class="filter-section">
        <label class="filter-label">{{ section.label }}</label>
        <component :is="section.component" v-bind="section.bind(filters)" />
      </div>

      <!-- Chips (Default) -->
      <div v-else-if="section.type === 'chips'" class="filter-section">
        <label class="filter-label">{{ section.label }}</label>
        <ChipSelect
          :options="resolveOptions(section)"
          :model-value="getByPath(filters, section.key)"
          @update:model-value="v => setByPath(filters, section.key, v)"
        />
      </div>

      <!-- Checkbox Group -->
      <template v-else-if="section.type === 'checkboxGroup'">
        <div v-for="group in resolveItems(section)" :key="group.key" class="filter-section">
          <label class="filter-label">{{ group.label }}</label>
          <BCheckbox
            v-for="option in group.options"
            :key="`${group.key}_${option}`"
            :model-value="filters[group.key][option]"
            @update:model-value="v => filters[group.key][option] = v"
            :label="option"
          />
        </div>
      </template>

    </template>

    <slot />
  </div>
</template>

<script>
import SortControl from "@/components/common/SortControl.vue";
import BCheckbox from "@/components/common/BCheckbox.vue";
import BSwitch from "@/components/common/BSwitch.vue";
import SegmentedControl from "@/components/common/SegmentedControl.vue";
import ChipSelect from "@/components/common/ChipSelect.vue";

function getByPath(obj, path) {
  const keys = path.split('.');
  let current = obj;
  for (const key of keys) {
    if (current == null) return undefined;
    current = current[key];
  }
  return current;
}

function setByPath(obj, path, value) {
  const keys = path.split('.');
  let current = obj;
  for (let i = 0; i < keys.length - 1; i++) {
    if (current[keys[i]] == null) current[keys[i]] = {};
    current = current[keys[i]];
  }
  current[keys[keys.length - 1]] = value;
}

export default {
  components: {ChipSelect, SortControl, BCheckbox, BSwitch, SegmentedControl },
  props: {
    filters: Object,
    sections: Array
  },
  computed: {
    visibleSections() {
      return (this.sections || []).filter(s => !s.visible || s.visible(this.filters));
    }
  },
  methods: {
    getByPath,
    setByPath,
    resolveOptions(section) {
      return typeof section.options === 'function' ? section.options(this.filters) : section.options;
    },
    resolveItems(section) {
      return typeof section.items === 'function' ? section.items(this.filters) : section.items;
    }
  }
}
</script>
